import { NavLink, useNavigate } from "react-router-dom";
import { useEffect, useState, ReactNode } from "react";
import SidebarMenu from "./sideBarMenu";
import routes from './sideBarRoutes';
import carton_logo from '../../assets/images/Tracksure_Carton_Box.png';
import Header from "../Header";
// import { logoutUser } from "../utils/api.authentication";
type SideBarProps = {
  children: ReactNode;
};

const SideBar: React.FC<SideBarProps> = ({ children }) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setIsOpen(false);
      } else {
        setIsOpen(true);
      }
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const onLogoutHandle = async () => {
    localStorage.clear();
    navigate('/');
  };

  return (
    <div className="main-container">
      <div
        style={{ width: 250 }}
        className='sidebar'
      >
        <div className="sticky overflowx-hidden overflow-y h-100vh">
          <div className="top_section">
            <div className="text-center" style={{ width: "100% !important", transform: "scale(1)" }}>
              <img src={carton_logo} height={90} width={190} className="m-t-20 m-b-20" alt="Logo" />
            </div>
          </div>

          <div className="d-flex space-between flex-direction-column bg-blue">
            <section className="routes">
              {routes.map((route, index) => {
                if (route.subRoutes) {
                  return (
                    <SidebarMenu
                      setIsOpen={setIsOpen}
                      route={route}
                      isOpen={isOpen}
                      key={index}
                    />
                  );
                }

                return (
                  <NavLink
                    to={route.path}
                    key={index}
                    className="link"
                  >
                    {isOpen && (
                      <div>
                        {route.name}
                      </div>
                    )}
                  </NavLink>
                );
              })}
            </section>

            {!(window.innerWidth <= 768) && (
              <div className="m-b-10">
                <div className="align-right p-r-10 APP-color">
                  <div className="d-flex justify-between link" style={{ padding: '10px 20px' }}>
                    <p className="cursor logout" onClick={onLogoutHandle}>Logout</p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <main className="scrollbar APP-background" style={{ width: isOpen ? "85%" : "calc(100% - 50px)" }}>
        <div><Header /></div>
        {children}
      </main>
    </div>
  );
};

export default SideBar;
